import React from "react";
import { useParams } from "react-router-dom";

import DetailPage from "../components/DetailPage";
import { getService } from "../data/services";

function ServiceDetail() {
  const { slug } = useParams();
  const service = getService(slug);

  return (
    <DetailPage
      item={service}
      kind="SERVICE"
      backTo="/services"
      backLabel="Back to Services"
      notFoundTitle="Service not found"
      notFoundText="The service you're looking for doesn't exist."
      listTitle="What We Deliver"
      listItems={service?.offerings}
      useCases={service?.useCases}
    />
  );
}

export default ServiceDetail;
